import React, { useEffect } from 'react';
import { parseAvatar } from '../../services/utilities';

export default function ViewProfileImage({ image, closeModal }) {
	useEffect(() => {
		document.body.classList.add('modal-open');
		return () => {
			document.body.classList.remove('modal-open');
		};
	}, []);

	return (
		<div className="onboarding-modal modal fade animated show" role="dialog" style={{ display: 'block' }}>
			<div className="modal-dialog modal-md modal-centered">
				<div className="modal-content text-center">
					<button aria-label="Close" className="close" type="button" onClick={closeModal}>
						<span className="os-icon os-icon-close" />
					</button>
					<div className="onboarding-content with-gradient">
						<h4 className="onboarding-title">Profile Image</h4>
						<div className="element-box m-0 p-2">
							<img src={parseAvatar(image)} alt="profile" style={{ width: '100%', maxWidth: '400px', height: 'auto' }} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
